import React, { Component } from "react";
import { Box, Typography, Paper } from "@mui/material";

// Feature data for better maintainability
const features = [
  {
    id: 1,
    title: "Games Selection",
    description: "Discover our extensive collection of games, perfect for keeping your customers entertained and coming back for more.",
    color: "primary.main"
  },
  {
    id: 2,
    title: "Wallpaper Selection",
    description: "Discover our extensive collection of wallpapers, perfect for personalizing your devices and keeping your customers engaged. Go get yourself too, try to customize for customers.",
    color: "secondary.main"
  },
  {
    id: 3,
    title: "Player Saves (Coming Soon)",
    description: "Saving game data is a crucial feature for any gaming platform. Our upcoming player save functionality will allow users to save their progress and continue their gaming experience seamlessly across sessions.",
    color: "error.main"
  },
  {
    id: 4,
    title: "Admin Management",
    description: "Save Games/Apps and more even customize the launcher for your cafe, with our admin management tools, you can easily manage your cafe's operations, all in one place.",
    color: "warning.main"
  }
];

class FeaturesSection extends Component {
  override render() {
    return (
      <Box
        sx={{
          width: "100%",
          py: { xs: 6, md: 10 },
          px: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{
            mb: 2,
            fontSize: {
              xs: "2rem",
              sm: "2.3rem",
              md: "2.7rem",
            },
            fontWeight: 700,
            color: "text.primary",
          }}
        >
          Features
        </Typography>
        
        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 5,
            maxWidth: 800,
            fontSize: {
              xs: "0.9rem",
              sm: "1rem",
              md: "1.1rem",
            },
            color: "text.secondary",
          }}
        >
          Everything you need to manage your cafe, all in one place. Our platform offers a comprehensive suite of features designed to streamline your operations, enhance customer experiences, and drive growth. From inventory management to sales analytics, our tools empower you to make informed decisions and optimize your business performance.
        </Typography>

        <Box
          sx={{
            width: "100%",
            maxWidth: 1200,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
            },
            gap: { xs: 3, md: 4 },
          }}
        >
          {features.map((feature) => (
            <Paper
              key={feature.id}
              elevation={3}
              sx={{
                height: { xs: 250, md: 300 },
                bgcolor: feature.color,
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 3,
                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 10,
                },
              }}
            >
              <Typography
                variant="h4"
                align="center"
                sx={{
                  fontSize: {
                    xs: "1.5rem",
                    sm: "1.8rem",
                    md: "2.2rem",
                  },
                  fontWeight: 700,
                  color: "white",
                  mb: 2,
                }}
              >
                {feature.title}
              </Typography>

              <Typography
                variant="body2"
                align="center"
                sx={{
                  fontSize: {
                    xs: "0.8rem",
                    sm: "0.9rem",
                    md: "1rem",
                  },
                  color: "rgba(255,255,255,0.9)",
                  maxWidth: 400,
                }}
              >
                {feature.description}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    );
  }
}

export default FeaturesSection;